var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .065)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#5C5C5C",
    width: 50,
    height: 50,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.643 36.571H15.357A5.363 5.363 0 0 1 10 31.214V18.357A5.363 5.363 0 0 1 15.357 13h19.286A5.363 5.363 0 0 1 40 18.357v12.857a5.363 5.363 0 0 1-5.357 5.357zM15.357 15.143a3.218 3.218 0 0 0-3.214 3.214v12.857a3.218 3.218 0 0 0 3.214 3.215h19.286a3.218 3.218 0 0 0 3.214-3.215V18.357a3.218 3.218 0 0 0-3.214-3.214H15.357zm14.372 9.643 5.671-5.671a1.07 1.07 0 1 0-1.515-1.515L25 26.485 16.115 17.6a1.07 1.07 0 1 0-1.515 1.515l5.67 5.67-5.67 5.672a1.07 1.07 0 1 0 1.515 1.515l5.67-5.671 2.457 2.457a1.068 1.068 0 0 0 1.515 0l2.457-2.457 5.671 5.67a1.068 1.068 0 0 0 1.515 0 1.07 1.07 0 0 0 0-1.514l-5.67-5.671z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9c5253cda607ec9bcb6234b26c7a1ec3.svg";
export { ForwardRef as ReactComponent };